import {
  WbSelectInline,
  WbSelectInlineItem,
} from '@agilelab/plugin-wb-platform';
import { camelToSpacedCase } from '@agilelab/plugin-wb-platform-common';
import { configApiRef, useApi } from '@mainstage/core-plugin-api';
import { Box, Theme, Typography, makeStyles } from '@material-ui/core';
import pluralize from 'pluralize';
import { useManageAssignmentsDrawerContext } from './ManageAssignmentsDrawerContext';
import { ScopeEnum } from './types';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export function EntityKindSelector({ disabled }: { disabled?: boolean }) {
  const classes = useStyles();
  const { selectedKind, setSelectedKind } = useManageAssignmentsDrawerContext();
  const configApi = useApi(configApiRef);
  const componentScopeEnabled =
    configApi.getOptionalBoolean(
      'mesh.platformSettings.rbac.experimental.componentScope',
    ) ?? false;

  const kinds = [
    { key: 'domains', value: ScopeEnum.domain },
    { key: 'systems', value: ScopeEnum.system },
    { key: 'systemTypes', value: ScopeEnum.systemType },
    ...(componentScopeEnabled
      ? [
          { key: 'components', value: ScopeEnum.component },
          { key: 'componentTypes', value: ScopeEnum.componentType },
        ]
      : []),
  ];

  return (
    <Box className={classes.container}>
      <WbSelectInline
        value={selectedKind}
        onChange={setSelectedKind}
        disabled={disabled}
        title="Category"
      >
        {...kinds.map(i => (
          <WbSelectInlineItem {...i}>
            <Typography variant="body2">
              {camelToSpacedCase(pluralize(i.key), true)}
            </Typography>
          </WbSelectInlineItem>
        ))}
      </WbSelectInline>
    </Box>
  );
}
